import React from 'react';
import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';

import NumberFormatInput from './NumberFormatInput';

const useStyles = makeStyles((theme) => ({
  phoneNumberAdornment: {
    borderRight: '1px solid',
    borderRightColor: theme.palette.grey.light,
    paddingRight: theme.spacing(2),
    height: 45,
    display: 'flex',
    alignItems: 'center',
  },
}));

const PhoneNumberInput = ({
  onChange,
  onKeyPress,
  onKeyUp,
  pattern,
  format,
  readOnly,
  disabled,
  value,
  autoFocus,
}) => {
  const classes = useStyles();

  return (
    <NumberFormatInput
      onChange={onChange}
      onKeyPress={onKeyPress}
      onKeyUp={onKeyUp}
      pattern={pattern}
      format={format}
      readOnly={readOnly}
      disabled={disabled}
      value={value}
      autoFocus={autoFocus}
      inputAdornment={
        <Typography variant="body2" component="div" className={classes.phoneNumberAdornment}>
          +61
        </Typography>
      }
      type="tel"
    />
  );
};

PhoneNumberInput.propTypes = {
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
  onKeyUp: PropTypes.func,
  pattern: PropTypes.string,
  format: PropTypes.string,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  autoFocus: PropTypes.bool,
};

PhoneNumberInput.defaultProps = {
  onChange: undefined,
  onKeyPress: undefined,
  onKeyUp: undefined,
  pattern: null,
  format: null,
  readOnly: false,
  disabled: false,
  value: null,
  autoFocus: false,
};

export default PhoneNumberInput;
